// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

type AlignX = 'left' | 'center' | 'right' | 'stretch';
type AlignY = 'top' | 'center' | 'bottom' | 'between' | 'around';

interface ColumnProps {
  gap?: number;
  alignX?: AlignX;
  alignY?: AlignY;
  isWrap?: boolean;
}

export default styled.div<ColumnProps>`
  display: flex;
  flex-direction: column;

  ${({ isWrap }) => {
    if (isWrap) {
      return 'flex-wrap: wrap;';
    }
  }}

  ${({ alignX }) => {
    switch (alignX) {
      case 'left':
        return 'align-items: flex-start;';
      case 'center':
        return 'align-items: center;';
      case 'right':
        return 'align-items: flex-end;';
      case 'stretch':
        return 'align-items: stretch;';
    }
  }}

  ${({ alignY }) => {
    switch (alignY) {
      case 'top':
        return 'justify-content: flex-start;';
      case 'center':
        return 'justify-content: center;';
      case 'bottom':
        return 'justify-content: flex-end;';
      case 'between':
        return 'justify-content: space-between;';
      case 'around':
        return 'justify-content: space-around;';
    }
  }}

  ${({ gap }) => {
    if (gap) {
      return `
        > * + * {
          margin-top: ${gap}px;
        }
      `;
    }
  }}
`;
